import React from 'react'
import { Helmet } from 'react-helmet-async'
import Landing from '../Esg/Landing'
import { FaAngleRight } from 'react-icons/fa6'
import EsgCard from '../Esg/EsgCard'
import CTO from '../Esg/CTO'
const ourSolutions = [
    {
        "title": "ENERGY EFFICIENCY IMPROVEMENT",
        "image": "/assets/images/our-sol-1.png",
        "description": "We assess and optimize energy consumption across operations, implementing solutions that reduce energy waste, lower costs, and enhance system performance. By adopting energy-efficient technologies and practices, businesses can achieve long-term sustainability while maintaining operational excellence."
    },
    {
        "title": "WATER CONSERVATION",
        "image": "/assets/images/our-sol-2.png",
        "description": "Our water management strategies focus on reducing water usage, recycling, and reusing resources wherever possible. We design solutions for efficient water utilization, helping companies save costs, comply with regulations, and contribute to global water sustainability efforts."
    },
    {
        "title": "RENEWABLE ENERGY",
        "image": "/assets/images/our-sol-3.png",
        "description": "We support the integration of renewable energy sources such as solar, wind, and bioenergy into industrial and commercial operations. By shifting from fossil fuels to clean energy, businesses can reduce their carbon footprint, energy costs, and reliance on non-renewable resources."
    },
    {
        "title": "GHG REDUCTION",
        "image": "/assets/images/our-sol-4.png",
        "description": "Our solutions help organizations identify and mitigate sources of greenhouse gas emissions. Through process optimization, clean technologies, and carbon management strategies, we enable businesses to achieve carbon neutrality goals and comply with evolving environmental regulations."
    },
    {
        "title": "MATERIAL CONSERVATION",
        "image": "/assets/images/our-sol-5.png",
        "description": "We assist businesses in optimizing the use of raw materials and resources, reducing wastage, and adopting sustainable sourcing practices. Material conservation ensures cost savings, resource efficiency, and alignment with sustainability objectives."
    },
    {
        "title": "WASTE MANAGEMENT",
        "image": "/assets/images/our-sol-6.png",
        "description": "We design and implement effective waste management systems, including reduction, recycling, and proper disposal strategies. By minimizing waste generation and promoting circular economy principles, companies can reduce environmental impact and improve operational efficiency."
    },
    {
        "title": "LIFE CYCLE ASPECTS",
        "image": "/assets/images/our-sol-7.png",
        "description": "Our solutions take a holistic view of products and processes, considering their environmental impact from production to end-of-life. Life cycle assessments help businesses identify improvement opportunities, reduce ecological footprints, and make informed sustainability decisions."
    },
    {
        "title": "INNOVATION FOR SUSTAINABLE DEVELOPMENT",
        "image": "/assets/images/our-sol-8.png",
        "description": "We leverage cutting-edge technologies, research, and innovative engineering approaches to develop sustainable solutions tailored to business needs. Innovation drives not only environmental benefits but also economic growth, operational efficiency, and long-term competitive advantage."
    }
]


function Solutions() {
    return (
        <>
            <Helmet>
                <title>Sustainable Engineering Solutions for Energy, Water, GHG & Waste Reduction | Nirantara</title>
                <meta name="description" content="Discover Nirantara's engineering solutions for energy efficiency, water conservation, renewable energy, GHG reduction, and waste management to drive sustainable business transformation." />
                <meta name="keywords" content="sustainable engineering solutions, energy efficiency improvement, water conservation solutions, renewable energy integration, GHG reduction strategies, waste management consulting, sustainable business transformation" />
                <link rel="canonical" href="https://nirantara.solutions/solutions" />
            </Helmet>
      <h1 className="sr-only">Sustainable Engineering Solutions</h1>
            <Landing text={"Sustainable Engineering \n Solutions"} image={"/esg-solution.jpg"} button={{
                text: "Talk to Our Expert", action: () => {
                    window.location.href = "/contact-us"
                },
                icon: <FaAngleRight />
            }} />

            <section className="w-full py-16 bg-gray-50 md:py-24" style={{ paddingLeft: '8%', paddingRight: '8%' }}>
                <div className="max-w-[1400px] mx-auto">
                    <h2 className="mb-8 text-3xl font-semibold text-black md:text-4xl lg:text-5xl" style={{ fontFamily: 'Poppins', fontWeight: 600, lineHeight: '1.3' }}>
                        Our Engineering Solutions – Driving Sustainable Transformation
                    </h2>
                    <div className="space-y-6 text-gray-700 montserrat">
                        <p className="text-base leading-relaxed tracking-wide md:text-lg">
                            At Nirantara, we provide comprehensive engineering solutions designed to help businesses reduce environmental impact, optimize resources, and achieve sustainable growth. Our approach combines innovation, technology, and practical strategies to address today’s most pressing environmental challenges.
                        </p>
                    </div>
                    <button className="mt-8 bg-[#e67e00] text-white px-6 py-3 rounded-md font-semibold flex items-center gap-2 hover:bg-[#163850]" onClick={() => window.location.href = "/contact-us"}>
                        Talk to Our Expert <FaAngleRight className="text-sm" />
                    </button>
                </div>
            </section>
            <div
                className="flex flex-col items-center w-full gap-10 sm:gap-14 px-[2rem] py-[2rem] sm:px-[5rem] md:px-[5rem] lg:px-[15rem]  montserrat bg-[#EDEDED]">
                <h5 className='font-bold text-center text-black text-[2.2rem] sm:pt-3'>Our Solutions</h5>
                <div className="grid grid-cols-1 gap-10 md:grid-cols-2 md:gap-16">
                    {ourSolutions && ourSolutions.length > 0 && ourSolutions.map((item, index) => {
                        const { title, subtitle, description, cta, image } = item;
                        return (
                            <EsgCard title={title} subtitle={subtitle} description={description} cta={cta} Icon={image} key={index} />
                        )
                    })}
                </div>
            </div>
            <CTO
                title={"Personalized solutions for smarter, greener operations. Get expert guidance now."}
                buttonText={"Talk to Our Expert"}
                description={null}
            />
        </>
    )
}

export default Solutions